import React from "react";
import { useTranslation } from "react-i18next";

export const FavoriteButton = ({
  isFavorite,
  onToggle,
  className = "",
}: {
  isFavorite: boolean;
  onToggle: (e: React.MouseEvent) => void;
  className?: string;
}) => {
  const { t } = useTranslation();
  const label = isFavorite ? t("favorite-remove") : t("favorite-add");

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={isFavorite}
      aria-label={label}
      title={label}
      className={`text-lg transition-colors ${
        isFavorite ? "text-warning" : "text-grey-medium"
      } hover:text-warning ${className}`}
    >
      ★
    </button>
  );
};

/** En-tête de la colonne des favoris : l'étoile pour l'œil, un nom pour les lecteurs d'écran. */
export const FavoriteHeader = () => {
  const { t } = useTranslation();
  return (
    <>
      <span aria-hidden="true">★</span>
      <span className="sr-only">{t("favorites")}</span>
    </>
  );
};
